import { NavLink, Outlet } from "react-router-dom";
import { L } from "../langauge/english.lang";
import LanguageDropdown from "../component/Auth/LanguageDropdown";
import { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { cn } from "../lib/utils";

const WalkThrough = ({ privacyMode, activeStep }) => {
  const [isOpen, setIsOpen] = useState(false);

  const steps = [
    { id: 1, label: L.RECORD, path: "/home/walkthrough/record" },
    { id: 2, label: L.REVIEW_NOTE, path: "/home/walkthrough/review-note" },
    { id: 3, label: L.WRAP_UP, path: "/home/walkthrough/wrap-up" },
  ];

  return (
    <div className="flex m-auto lg:flex-row flex-col w-full relative h-[calc(100vh-86px)] bg-[#f5f6f6] py-2.5 px-4 gap-4 overflow-y-auto">
      <div className="max-w-[348px] min-h-[350px] w-full hidden lg:flex flex-col gap-2.5 ">
        <div className="flex flex-col h-full">
          <div className="p-4 bg-white rounded-lg hidden md:block">
            <div className="font-bold border-b-2 border-[#f5f5f5] pb-3 text-base md:text-[24px]">
              {L.WALKTHROUGH}
            </div>

            <div className="mt-3">
              {steps.map((s, index) => (
                <NavLink
                  key={index}
                  to={s.path} // must be present but won't trigger
                  onClick={(e) => e.preventDefault()} // disables navigation
                  className={({ isActive }) =>
                    cn(
                      "px-4 py-3 mt-1.5 font-medium text-base rounded-md block text-black",
                      isActive && "bg-[#f1f5f5]",
                    )
                  }
                >
                  {s.label}
                </NavLink>
              ))}
            </div>
          </div>
          {/* <div className="w-96 flex mt-auto mb-24">
            <LanguageDropdown />
          </div> */}
        </div>
      </div>

      {isOpen && (
        <div className="lg:hidden w-[320px] left-0 top-0 slideInLeft z-40 absolute h-full bg-white p-4 border-r-2 ">
          <div className="flex items-center justify-end w-full mb-3">
            <button onClick={() => setIsOpen(false)}>
              <ChevronLeftIcon fontSize="large" />
            </button>
          </div>

          <div className=" w-full  flex flex-col gap-2.5 ">
            <div className="flex flex-col h-full">
              <div className="lg:p-4 lg:mb-0 mb-4 bg-white rounded-lg">
                <div className="font-bold border-b-2 border-[#f5f5f5] pb-3 text-base md:text-[24px]">
                  {L.WALKTHROUGH}
                </div>

                <div className="mt-3">
                  {steps.map((s, index) => (
                    <div
                      key={index}
                      className={`px-4 py-3 mt-1.5 font-medium text-sm md:text-base rounded-md ${
                        activeStep === s.id ? "bg-[#f1f5f5] " : ""
                      }`}
                    >
                      {s.label}
                    </div>
                  ))}
                </div>
              </div>
              <div className="max-w-96 w-full flex mt-auto mb-24">
                <LanguageDropdown />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="lg:hidden pt-2">
        <button onClick={() => setIsOpen(true)}>
          <MenuIcon size={24} />
        </button>
      </div>

      <div className="min-w-[250px] flex-grow md:min-h-[350px] flex-1  w-full flex flex-col gap-2.5 md:h-full  rounded-lg p-2 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default WalkThrough;
